import React from 'react';

import { t } from '../app/shared/components/l10n/l10n';

export const getErrorMessage = (error: any, errorMessage?: string, registeredFields?: Record<string, any>) => {
    if (error.validation) {
        return (
            <ul className="mb-0">
                {Object.keys(error.validation).map(key => (
                    <li key={key}>
                        {registeredFields?.[key] ? `${registeredFields[key]}: ${error.validation[key]}` : error.validation[key]}
                    </li>
                ))}
            </ul>
        );
    }

    return errorMessage || error.message;
};

export const getAPIErrorValidation = (error: any, values?: Record<string, any>) => {
    if (!error.validation && error.response && error.response.data) {
        return Object.keys(error.response.data).reduce((accum, key) => {
            const errorItem = Array.isArray(error.response.data[key]) ? error.response.data[key][0] : error.response.data[key];

            // handle error in case that it has object shape
            if (typeof errorItem === 'object') {
                return {
                    ...accum,
                    [key]: t(
                        `ERROR_CODE_${errorItem.errorCode}`,
                        Object.entries(errorItem.data).reduce((obj, [key, value]) => {
                            obj[key.toUpperCase()] = value;
                            return obj;
                        }, {})
                    ),
                };
            }

            return {
                ...accum,
                [key]: t(`ERROR_CODE_${errorItem}`, { VALUE: values ? values[key] : key }),
            };
        }, {});
    }

    return error.validation;
};
